import EnLang from "./entries/en-US";
import FaLang from "./entries/fa_IR";

export const AppLocale: { [lang: string]: any } = {
  fa: FaLang,
  en: EnLang,
};
